import { render, staticRenderFns } from "./ShopSingleProduct.vue?vue&type=template&id=514341ed"
import script from "./ShopSingleProduct.vue?vue&type=script&lang=ts"
export * from "./ShopSingleProduct.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports